/*
 * please follow the wiki: http://wiki.corp.qunar.com/pages/viewpage.action?pageId=105923056
 * @providesModule QImageSet
 */

// export default QImageSet = {
module.exports = {
    // clearIcon: 'https://s.qunarzz.com/cmn_city_select_rn/score/assets/0.0.3/clear.png',
    // noDataImage: 'https://s.qunarzz.com/ordercenter_mobile/images/order_login.png',
    // arrowEnd: 'https://s.qunarzz.com/ppfe/cmn_order_rn/images/arrow1.png',
    // arrowFront: 'https://s.qunarzz.com/ppfe/cmn_order_rn/images/arrow2.png',
    // searchIconHd: 'https://source.qunarzz.com/ordercenter/new_mobile/search-icon-hd.png',
    loading: 'https://picbed.qunarzz.com/d6d5abe2c3d99f92860a3d461aec2cbf.png',

    // noNetwork: 'https://s.qunarzz.com/ppfe/cmn_order_rn/images/no-network.png',//***
    // noOrder: 'https://s.qunarzz.com/ppfe/cmn_order_rn/images/no-order.png',//***
    noNetwork: 'https://picbed.qunarzz.com/f26dec0c8dc68a696f5eddacdd81ee82.png',//***
    noOrder: 'https://picbed.qunarzz.com/a0042ca33985b2d6f2536599697dec00.png',//***

    centerLoadingViewBg:'https://picbed.qunarzz.com/3c8c5f80279a3b1b17d0475c0aadb556.png',

};
